import script from "./PaymentStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusModal.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusModal.vue?vue&type=style&index=0&id=3330a716&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3330a716"]])

export default __exports__